/* @flow */

import React, { Component } from 'react';
import { Button, Item, Dimmer } from 'semantic-ui-react';
import BlockTemplateImage from './BlockTemplateImage';
import BlockOrderButtons from './BlockOrderButtons';
import { getViewComponent } from 'edito/plugin';

type Props = {
  templates: Array<EditorialBlockTemplate>,
  block: EditorialBlock,
  blocks: List<EditorialBlock>,
  onEdit: () => void,
  onOrderChanged: (order: number) => void,
  onDelete: () => void,
  locked?: boolean,
};

type State = {
  dimmerActive: boolean,
};

const styles = {
  action: {
    marginLeft: '1.5em',
    display: 'flex',
  },
};

class ViewBlockItem extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      dimmerActive: false,
    };
  }

  onShowDimmer = () => this.setState({ dimmerActive: true });
  onHideDimmer = () => this.setState({ dimmerActive: false });

  renderContent() {
    const { block } = this.props;

    const content = getViewComponent(block);
    if (content === null) {
      console.warn(`Unknown view block type ${block.template}. Cannot render`);
    }

    return content;
  }

  renderDimmerContent() {
    const { onEdit, onDelete, locked } = this.props;

    return (
      <div>
        <Button
          type="button"
          onClick={onEdit}
          icon="edit"
          labelPosition="right"
          content="Modifier"
        />
        {!locked &&
          <Button
            type="button"
            onClick={onDelete}
            icon="close"
            color="red"
            labelPosition="right"
            content="Supprimer"
          />}
      </div>
    );
  }

  render() {
    const { templates, block, blocks, onOrderChanged } = this.props;
    const { dimmerActive } = this.state;

    const canOrderUp = block.order > 0;
    const canOrderDown = block.order < blocks.size - 1;
    const orderUp = () => onOrderChanged(block.order - 1);
    const orderDown = () => onOrderChanged(block.order + 1);

    return (
      <Item>
        <BlockTemplateImage templates={templates} block={block} />
        <Dimmer.Dimmable
          className="ui middle aligned content"
          dimmed={dimmerActive}
          onMouseEnter={this.onShowDimmer}
          onMouseLeave={this.onHideDimmer}
        >
          <Dimmer active={dimmerActive} inverted>
            {this.renderDimmerContent()}
          </Dimmer>
          <div className="content">
            {this.renderContent()}
          </div>
        </Dimmer.Dimmable>
        <div className="ui small action" style={styles.action}>
          <BlockOrderButtons
            canOrderUp={canOrderUp}
            canOrderDown={canOrderDown}
            onOrderUp={orderUp}
            onOrderDown={orderDown}
          />
        </div>
      </Item>
    );
  }
}

export default ViewBlockItem;



// WEBPACK FOOTER //
// ./src/modules/edito/components/ViewBlockItem.js